import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { colors, fontSizes } from '@/styles'

const DropdownLinkItem = styled.a`
  font-family: var(--font-open-sans, 'Open Sans', sans-serif);
  background: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: calc(100% - 8px);
  text-decoration: none;
  color: ${({ hasEssentialsPlan }) =>
    hasEssentialsPlan ? colors.grey64 : colors.regular};
  font-size: ${fontSizes.regular};
  font-weight: 600;
  letter-spacing: -0.2px;
  line-height: 20px;
  margin: 0 4px;
  padding: 12px 10px;
  border-radius: 6px;
  cursor: pointer;

  > span {
    color: ${colors.link};
    margin-left: auto;
  }

  :hover {
    background-color: ${colors.grey96};
  }
`

const LeftIconContainer = styled.div`
  display: flex;
  align-items: flex-end;
  margin-right: 15px;
  bottom: 8.33%;
`

const DropdownLink = ({
  id,
  href,
  leftIcon,
  title,
  hasEssentialsPlan,
  onClick,
  children
}) => {
  const { t } = useTranslation()
  const internalLink = !onClick && !href.startsWith('http')

  const LinkComponent = props => (
    <DropdownLinkItem
      id={id}
      as={onClick ? 'button' : 'a'}
      onClick={onClick}
      hasEssentialsPlan={hasEssentialsPlan}
      {...props}
    >
      {leftIcon ? <LeftIconContainer>{leftIcon}</LeftIconContainer> : null}
      {title}
      {children}
      {hasEssentialsPlan && <span>{t('Upgrade', 'Upgrade')}</span>}
    </DropdownLinkItem>
  )

  return (
    <>
      {internalLink ? (
        <Link href={href} passHref legacyBehavior>
          <LinkComponent />
        </Link>
      ) : (
        <LinkComponent href={onClick ? undefined : href} />
      )}
    </>
  )
}

export default DropdownLink
